import api from "api/api";

const BASE_URL = "studio/bookings/";
const BASE_URL_SCHEDULE = "studio/schedules/";

export const getTodayBookingsForCoach = async (coachId, headers = {}, userGroups = []) => {
  // Secretarias y admins pueden ver TODAS las clases del día
  // Solo coaches ven sus propias clases
  const isCoach = userGroups.includes('coach');
  const url = (coachId && isCoach) 
    ? `${BASE_URL_SCHEDULE}today/?coach_id=${coachId}` 
    : `${BASE_URL_SCHEDULE}today/`;
  const response = await api.get(url, { headers });
  return response.data;
};

export const updateAttendance = async (bookingId, attendanceStatus) => {
  try {
    const url = `${BASE_URL}${bookingId}/attendance/`;
    const data = { attendance_status: attendanceStatus };
    const response = await api.put(url, data);
    return response.data;
  } catch (error) {
    console.error("Error al actualizar asistencia:", error);
    throw error;
  }
};

export const getAvailabilityByDate = async (date, params = {}, headers = {}) => {
  try {
    const queryParams = { ...params, date };
    const url = "studio/availability/";
    
    console.log('🔍 Debug getAvailabilityByDate:', {
      url,
      queryParams,
      headers,
      fullUrl: `${api.defaults.baseURL}${url}`
    });
    
    const response = await api.get(url, { 
      params: queryParams, 
      headers,
      timeout: 10000 // 10 segundos timeout
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener disponibilidad:", error);
    if (error.code === 'ERR_NETWORK') {
      console.error("❌ Network Error - Posible problema con DevTools o CORS");
    }
    throw error;
  }
};

export const getBookingsByClient = async (clientId, sedeParams = {}, sedeHeaders = {}) => {
  try {
    const url = `${BASE_URL}by-client/${clientId}/`;
    const response = await api.get(url, { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener historial del cliente ${clientId}:`, error);
    throw error;
  }
};

export const fetchAllBookings = async (sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(`${BASE_URL}historial/`, { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error("Error al obtener bookings:", error);
    throw error;
  }
};

export const getClassTypeSummary = async (sedeParams = {}, sedeHeaders = {}) => {
  const response = await api.get("studio/summary-by-class-type/", { params: sedeParams, headers: sedeHeaders });
  return response.data;
};

export const getAttendanceSummary = async (sedeParams = {}, sedeHeaders = {}) => {
  const response = await api.get("studio/attendance-summary/", { params: sedeParams, headers: sedeHeaders });
  return response.data;
};

export const getBookingsByDate = async (date, params = {}, headers = {}) => {
  try {
    const queryParams = { ...params, date };
    const url = `${BASE_URL}historial/`;
    
    console.log('🔍 Debug getBookingsByDate:', {
      url,
      queryParams,
      headers,
      fullUrl: `${api.defaults.baseURL}${url}`
    });
    
    const response = await api.get(url, { 
      params: queryParams, 
      headers,
      timeout: 10000 // 10 segundos timeout
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener reservas por fecha:", error);
    if (error.code === 'ERR_NETWORK') {
      console.error("❌ Network Error - Posible problema con DevTools o CORS");
    }
    throw error;
  }
};


export const registerBooking = async (payload, sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.post(`${BASE_URL}`, payload, { 
      params: sedeParams, 
      headers: sedeHeaders 
    });
    return response.data;
  } catch (error) {
    console.error("Error al registrar booking:", error);
    throw error;
  }
};

export const cancelBooking = async (bookingId, by = "admin", reason = "Cancelado desde recepción") => {
  const url = `${BASE_URL}${bookingId}/cancel/`;
  return await api.put(url, { by, reason });
};


export const fetchAllSchedules = async (sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(`${BASE_URL_SCHEDULE}`, { params: sedeParams, headers: sedeHeaders });
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.results)) return data.results;
    if (Array.isArray(data?.data)) return data.data;
    return [];
  } catch (error) {
    console.error("Error al obtener horarios:", error);
    throw error;
  }
};

/** Assign/update coach (and related fields) on a schedule. */
export const updateScheduleCoach = async (scheduleId, payload, sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.patch(`${BASE_URL_SCHEDULE}${scheduleId}/`, payload, {
      params: sedeParams,
      headers: sedeHeaders,
    });
    return response.data;
  } catch (error) {
    console.error("Error al actualizar coach del horario:", error);
    throw error;
  }
};


